import { Content } from "@iventis/translations/content/typed-content";
import React, { FunctionComponent } from "react";
import { TextField } from "@mui/material";
import { Formik, FormikHelpers } from "formik";
import { useHistory } from "@iventis/subscriptions";

import * as Yup from "yup";
import { FormLabel } from "@iventis/styles/src/components/texts";
import { SolidButton } from "@iventis/styles/src/components/button";
import { StyledFieldLabel } from "@iventis/styles/src/components/forms";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { passwordHeaderMargin } from "@iventis/styles/src/atomic-rules";
import { media, muiInputFormsCSS, styled } from "@iventis/styles";
import { forgotPassword } from "./set-password";

export const ForgottenPasswordForm: FunctionComponent = () => {
    const history = useHistory();
    const translate = useIventisTranslate();
    interface Values {
        email: string;
    }
    return (
        <Formik
            initialValues={{
                email: "",
            }}
            validationSchema={Yup.object({
                email: Yup.string().email(translate(Content.login.error.invalid)).required(Content.login.error.required),
            })}
            onSubmit={(values: Values, { setSubmitting }: FormikHelpers<Values>) => {
                // TODO: send email logic
                forgotPassword(values.email); // No need to await - Just assume its 200 as its forgot password.
                setSubmitting(false);
                history.push("/forgotten-password/email-sent");
            }}
        >
            {(props) => {
                const { errors, values, touched, handleChange, handleBlur, handleSubmit } = props;
                return (
                    <StyledForgotPasswordForm
                        data-testid="forgot-pass-form"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                        onSubmit={handleSubmit}
                    >
                        <div style={{ height: "80px", display: "block" }}>
                            <StyledFieldLabel id="email-label" data-testid="email-label" htmlFor="email-input">
                                <FormLabel>{translate(Content.login.labels.email)}</FormLabel>
                            </StyledFieldLabel>
                            <TextField
                                style={{ width: "100%" }}
                                id="email-input"
                                variant="outlined"
                                aria-labelledby="email-label"
                                name="email"
                                data-cy="email"
                                type="email"
                                error={errors.email && touched.email}
                                value={values.email}
                                placeholder={translate(Content.login.placeholders.email)}
                                inputProps={{
                                    "data-testid": "email-input",
                                }}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                helperText={errors.email && touched.email && errors.email}
                                autoComplete="username"
                            />
                        </div>
                        <StyledResetButton
                            id="forgot-pass-submit-btn"
                            data-testid="submit-button"
                            style={{ marginTop: passwordHeaderMargin, whiteSpace: "nowrap" }}
                            size="large"
                            type="submit"
                        >
                            {translate(Content.login.buttons.sendLink)}
                        </StyledResetButton>
                    </StyledForgotPasswordForm>
                );
            }}
        </Formik>
    );
};

export const StyledResetButton = styled(SolidButton)`
    display: flex;
    width: 158px;
    align-self: flex-end;
`;

const StyledForgotPasswordForm = styled.form`
    ${muiInputFormsCSS};
    min-width: 100%;
    ${media.extraSmall} {
        padding: 0;
    }
`;
